import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { CATEGORY_CODES } from '_constants/categories';
import { theme } from '_constants/theme';
import { selectCredentialsByCategory } from '_store/credentials/selector';
import { selectDetails as selectUserDetails } from '_store/user/selector';

import Navbar from './Navbar';

const items = [
  {
    iconAlias: null,
    title: 'Profile',
    path: '/account/profile',
  },
  {
    iconAlias: null,
    title: 'Billing',
    path: '/account/billing',
  },
  {
    iconAlias: null,
    title: 'Treatments',
    path: '/account/subscriptions',
  },
];

const StyledOuterContainer = styled.div`
  display: flex;
  justify-content: center;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 20;
  background-color: ${theme.colors.deepBlueGreen};
`;

const StyledInnerContainer = styled.div`
  max-width: ${theme.spaces.large26X * 10 + 32}px;
  width: 100%;

  padding-left: ${theme.spaces.regular}px;
  padding-right: ${theme.spaces.regular}px;
`;

const Header = ({ containerRef }) => {
  const credentials = useSelector(selectCredentialsByCategory(CATEGORY_CODES.main));
  const userDetails = useSelector(selectUserDetails);

  return (
    <StyledOuterContainer ref={containerRef}>
      <StyledInnerContainer>
        <Navbar items={items} userDetails={{ ...userDetails, monexaUsername: credentials?.username }} />
      </StyledInnerContainer>
    </StyledOuterContainer>
  );
};

Header.propTypes = {
  containerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
};

export default Header;
